import { createSlice } from '@reduxjs/toolkit';

import { IPurchasesState } from './interfaces';
import { loadPurchasesItem, loadPurchasesList } from './actions';

export const purchasesSlice = createSlice({
  name: 'purchases',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IPurchasesState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadPurchasesList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadPurchasesItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
